<div style="display: flex">
  <div style="display: flex; flex-direction: column; flex: 1vh">
    <div style="display: flex; flex-direction: row; flex: 100vh">
      <div style="display: flex; flex-direction:column; flex: 0 50vw; align-items: center;">
        <div style="width: 240px; margin: auto;">
          <ng-container *ngIf="success === true">
            <div>
              A reset code has been send to your email if there is a login associated with it. The reset code will expire in 10 minutes.
            </div>
            <div>
              <a style="color:#0094ff; font-size: 13px; text-decoration: underline; cursor: pointer" (click)="clickButton('cancel')">Back to Login</a>
            </div>
          </ng-container>
          <ng-container *ngIf="success === false">
            <dynamic-form [model]="form" (clickSubmit)="resetPassword($event)" (clickButton)="clickButton($event)">
            </dynamic-form>
          </ng-container>
        </div>
      </div>
      <div class="login-hero">
        <div class="login-hero-text">
          Join the most satisfied auto transport customers in the country.
        </div>
      </div>
    </div>
  </div>
</div>





